var map = {
	"./almonds.jpg": 3769,
	"./apricots.jpg": 8872,
	"./arborio.jpg": 3847,
	"./basmati.jpg": 5948,
	"./birdseye.jpg": 7022,
	"./black.jpg": 1992,
	"./blackbeans.jpg": 2255,
	"./brown.jpg": 1457,
	"./cardamom.jpg": 9729,
	"./cashews.jpg": 4309,
	"./cayenne.jpg": 1766,
	"./chickpeas.jpg": 6016,
	"./chipotle.jpg": 9379,
	"./cloves.jpg": 6487,
	"./coriander.jpg": 128,
	"./cumin.jpg": 6905,
	"./dates.jpg": 9314,
	"./fenugreek.jpg": 4237,
	"./figs.jpg": 6084,
	"./ghostpepper.jpg": 3368,
	"./greenchilli.jpg": 4207,
	"./greenpeas.jpg": 9941,
	"./habanero.jpg": 7269,
	"./hazelnuts.jpg": 1175,
	"./jalapeno.jpg": 4867,
	"./jasmine.jpg": 1374,
	"./kidneybeans.jpg": 4656,
	"./lentils.jpg": 3982,
	"./mace.jpg": 4939,
	"./mungbeans.jpg": 3969,
	"./mustard.jpg": 2847,
	"./nutmeg.jpg": 6315,
	"./paprika.jpg": 9681,
	"./parboiled.jpg": 2141,
	"./pepper.jpg": 5477,
	"./pigeonpeas.jpg": 9162,
	"./pistachios.jpg": 3086,
	"./prunes.jpg": 3890,
	"./raisins.jpg": 7208,
	"./red.jpg": 4316,
	"./redchilli.jpg": 7923,
	"./redlentils.jpg": 6593,
	"./scotchbonnet.jpg": 4245,
	"./sella.jpg": 7356,
	"./soybeans.jpg": 9337,
	"./sticky.jpg": 5988,
	"./turmeric.jpg": 2014,
	"./walnuts.jpg": 5069,
	"./wild.jpg": 381,
	"./yellowpeas.jpg": 3044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7582;